import React, { useState } from "react";
import moment from "moment";
import { Checkbox, Button } from "antd";
import Table_Icon from "../../../../assets/images/table.svg";
import Packet_Icon from "../../../../assets/images/packet.svg";
import Bike_Icon from "../../../../assets/images/bike.svg";
import { groupByMealCourse } from "./helper";

const cardClass = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
};
const orderType = {
  POS: Table_Icon,
  ONLINE_DELIVERY: Bike_Icon,
  ONLINE_TAKEOUT: Packet_Icon,
  ONLINE_CATERING: Packet_Icon,
};
const Card = (props) => {
  const {
    cardData = [],
    expoGroup = "HIGH",
    onSendOrder,
    selectedMenuItemId
  } = props;
  const [isSentToKitchen, setisSentToKitchen] = useState(
    cardData.map(item => item.is_sent_to_kitchen? item.id : null)
  );

  const handleCheckboxChange = (value, idx) => {
    const idList = idx.map((it)=> it.id)
    let currentItems = [...isSentToKitchen];
    if(isSentToKitchen.indexOf(idList[0]) > -1){
      idList.map((ids)=>{
        currentItems.splice(currentItems.indexOf(ids), 1);
      });
      setisSentToKitchen(currentItems);
    } else {
      currentItems= [...currentItems, ...idList];
      setisSentToKitchen(currentItems);
    }
  }

  const onBumpOrder = () => {
    const values = cardData.map((item, idx) => ({
      ...item,
      is_sent_to_kitchen: isSentToKitchen.indexOf(item.id) > -1 ? true : false,
    }));
    onSendOrder(values)
  }
  
  const firstOrder = cardData[cardData.length - 1];

  const shouldHighlight =
    cardData.some((card) => card.menu_item.id === selectedMenuItemId);

  const flashCalculation = (itemData) => {
    const blinkTime = moment(itemData?.cart?.created_at).add(itemData.flash_time, 'minutes');
    const currentTime = moment();
    if (blinkTime.isSameOrBefore(currentTime) && !itemData.is_sent_to_kitchen){
      return true;
    } else {
      return false;
    }
  };
  const cardFlashLogic = () => {
    let showFlash = false;
    cardData.map((mitem)=>{
      if(flashCalculation(mitem)){
        showFlash = true
      }
    })
    return showFlash;
  }
  if (!cardData.length) {
    return null;
  }
    
  return (
    <div
      className="expo_card"
      style={{
        opacity: selectedMenuItemId ? shouldHighlight ? 1 : 0.5 : 1,
      }}
    >
      <div className={(cardFlashLogic() ? "head_title blinking-header " : "head_title ")  + cardClass[firstOrder.kitchen_priority]}>
        <div>
          <img src={orderType[firstOrder.cart.order_type]} alt="" />
        </div>
        <div>{moment(firstOrder.updated_at).fromNow()}</div>
      </div>
      <div className={cardFlashLogic() ? "card_content blink-border" : "card_content"}>
        {groupByMealCourse(cardData).map((courseList)=>{
          return <div className={isSentToKitchen.indexOf(courseList[0].id) > -1 ? 'bg_mealgroup_red' : 'bg_mealgroup_unselect'}>
            <div className="meal_heading" >
              <div className="meal_name">{courseList[0].menu_item?.meal_course?.name}</div>
               <div>
                    <Checkbox
                      size="small"
                      checked={isSentToKitchen.indexOf(courseList[0].id) > -1}
                      // onChange={(e) => handleCheckboxChange(e.target.checked, idx)}
                       onChange={(e) => handleCheckboxChange(e.target.checked, courseList)}
                    />
              </div>
            </div>
          { courseList.map((itm)=>{
            return  <div className={flashCalculation(itm) ? "content_item item_blink" : "content_item"} key={itm.id}>
            <div className="content_rowtext">
              <div>{itm.quantity}</div>
              <div className="cross">x</div>
              <div className="item_name">
                <div className="name_row">
                  <div>{itm.menu_item.name}</div>
                 
                </div>
                <p className="item_info">Note: -</p>
              </div>
            </div>
          </div>
          })
        }</div>
        })}
        <Button
          type="primary"
          className="bump_btn"
          onClick={onBumpOrder}
        >
          Bump
        </Button>
      </div>
    </div>
  );
};
export default Card;
